import { writable } from 'svelte/store';

type ErrorData = {
	title?: string;
	description?: string;
	primaryButton?: string;
	cancelButton?: string;
	type?: 'confirm' | 'alert';
	onConfirm?: () => void | Promise<void>;
};

export const createErrorStore = (defaultStore: ErrorData | null) => {
	const { subscribe, set } = writable(defaultStore);

	return {
		subscribe,
		setError: (error: ErrorData) => {
			set(error);
		},
		clearError: () => {
			set(null);
		}
	};
};

export type ErrorStoreType = ReturnType<typeof createErrorStore>;
